export default "__VITE_ASSET__ab206dcd__"